import { render, staticRenderFns } from "./DownloadButtonNew.vue?vue&type=template&id=6a5de642&scoped=true&"
import script from "./DownloadButtonNew.vue?vue&type=script&lang=js&"
export * from "./DownloadButtonNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5de642",
  null
  
)

export default component.exports